import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-letter-harry-potter-01-the-cupboard-under-the-stairs",
  name: `Harry Potter Acceptance Letter\n'The Cupboard under the Stairs'`,
  nameFormatted: {
    primary: "Harry Potter Acceptance Letter",
    secondary: "'The Cupboard under the Stairs'",
  },
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
